// 3rd party imports
import { Type } from 'class-transformer';

// Common imports
import { Utils } from 'cc-common';

// Model imports
import { KeyValueResultDto } from '../../_models/key-value-result-dto';
import { BlockIssuesResultDto } from './block-issues-result-dto';
import { ConveyanceCommunityARBankResultDto } from './conveyance-community-ar-bank-result-dto';
import { ConveyanceCommunityResultDto } from './conveyance-community-result-dto';
import { ConveyanceCommunitySoaRequestsRawDto } from './conveyance-community-soa-requests-raw-dto';
import { ConveyancePropertyInfoResultDto } from './conveyance-property-info-result-dto';

export class ConveyanceEditorResultDto {
    @Type(() => BlockIssuesResultDto)
    blockIssues: BlockIssuesResultDto[];

    @Type(() => ConveyanceCommunityResultDto)
    conveyanceCommunities: ConveyanceCommunityResultDto[];

    @Type(() => ConveyancePropertyInfoResultDto)
    property: ConveyancePropertyInfoResultDto;

    sellerName: string;
    buyerName: string;
    openViolationCount: number;

    @Type(() => KeyValueResultDto)
    conveyanceTypes: KeyValueResultDto[];

    @Type(() => ConveyanceCommunityARBankResultDto)
    communityARDefaultBankNames: ConveyanceCommunityARBankResultDto[];

    @Type(() => Date)
    minClosingDate: Date;

    @Type(() => Date)
    maxClosingDate: Date;

    @Type(() => Date)
    defaultGLPostDate: Date;

    @Type(() => Date)
    minGLPostDate: Date;

    @Type(() => Date)
    maxGLPostDate: Date;

    @Type(() => Date)
    maxPaperworkReceivedDate: Date;

    @Type(() => ConveyanceCommunitySoaRequestsRawDto)
    conveyanceSOARequests: ConveyanceCommunitySoaRequestsRawDto;

    hasCorpAccountingEnabled: boolean;

    // Transient
    get conveyanceHasOpenViolations(): boolean {
        return Utils.notNullAndDefined(this.openViolationCount) && this.openViolationCount > 0;
    }
}
